/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ap-northeast-1",
    "aws_dynamodb_all_tables_region": "ap-northeast-1",
    "aws_dynamodb_table_schemas": [
        {
            "tableName": "confirmtable-prd",
            "region": "ap-northeast-1"
        }
    ],
    "aws_cloud_logic_custom": [
        {
            "name": "confirmapi",
            "endpoint": "https://v19w3tb2ak.execute-api.ap-northeast-1.amazonaws.com/prd",
            "region": "ap-northeast-1"
        }
    ],
    "aws_content_delivery_bucket": "confirm-20200806102454-hostingbucket-prd",
    "aws_content_delivery_bucket_region": "ap-northeast-1",
    "aws_content_delivery_url": "https://d2oivf8ysa8wp0.cloudfront.net"
};


export default awsmobile;
